import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';
import { Md5 } from 'ts-md5';
import { UserCredentials } from '../models/Credentials.model';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm;
  constructor(public authService: AuthService) {
  }

  ngOnInit() {
    if (this.authService.isAuthenticated() && this.authService.isLoggedIn()) {
      this.authService.routeUserToStartpage();
    }
    this.initForm();
    console.log('APP version: ', environment.version);
  }

  private initForm() {
    this.loginForm = new FormGroup({
      name: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required)
    });
  }

  onSubmit() {
    const md5 = new Md5();
    let hashedPw: string = md5.appendStr(this.loginForm.value.password).end().toString();
    let credential: UserCredentials = new UserCredentials();
    credential.email = this.loginForm.value.name;
    credential.password = hashedPw;

    let subscription = this.authService.authenticateUser(credential)
      .pipe(finalize(() => {
        subscription.unsubscribe();
      }))
      .subscribe(
        {
          next: (response: any) => this.authService.authenticationSucces(response),
          error: (e: any) => this.authService.authenticationError(e),
          complete: null
        });
  }

  ngOnDestroy() {
  }
}
